module.exports = __webpack_public_path__ + "static/media/Camplete TurnMill Resource Manager.ade1fa4b.png";